import { Component } from '@angular/core';

@Component({
  selector: 'atlas-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  standalone: false,
})
export class ChipComponent {}
